var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.59668,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2881 22.9072L21.8057 12.441H22.5558C22.8634 12.441 23.1109 12.1976 23.1109 11.9041C23.1109 11.6105 22.8634 11.36 22.5558 11.36H19.2778V10.2862C19.2778 9.26245 18.5502 8.59668 17.395 8.59668H14.5896C13.4344 8.59668 12.7143 9.26245 12.7143 10.2862V11.36H9.45126C9.15121 11.36 8.88867 11.6105 8.88867 11.9041C8.88867 12.1976 9.15121 12.441 9.45126 12.441H10.2014L10.719 22.9144C10.7715 23.9452 11.4841 24.5967 12.5642 24.5967H19.4428C20.5155 24.5967 21.2356 23.9381 21.2881 22.9072ZM13.9143 10.3577C13.9143 9.94966 14.2293 9.6633 14.6794 9.6633H17.3123C17.7699 9.6633 18.0849 9.94966 18.0849 10.3577V11.3599H13.9143V10.3577ZM12.6773 23.5228C12.2422 23.5228 11.9197 23.2078 11.8972 22.7926L11.3721 12.4409H20.606L20.1109 22.7926C20.0884 23.215 19.7734 23.5228 19.3308 23.5228H12.6773ZM18.2273 22.2629C18.4748 22.2629 18.6623 22.0696 18.6698 21.7976L18.8949 14.2379C18.9024 13.9658 18.7074 13.7654 18.4523 13.7654C18.2198 13.7654 18.0247 13.973 18.0172 14.2307L17.7922 21.7976C17.7847 22.0553 17.9722 22.2629 18.2273 22.2629ZM13.7792 22.2629C14.0342 22.2629 14.2217 22.0553 14.2142 21.7976L13.9892 14.2307C13.9817 13.973 13.7792 13.7654 13.5466 13.7654C13.2916 13.7654 13.104 13.9658 13.1115 14.2379L13.3441 21.7976C13.3516 22.0696 13.5316 22.2629 13.7792 22.2629ZM16.4576 21.7976C16.4576 22.0553 16.2475 22.2629 16.0075 22.2629C15.7599 22.2629 15.5499 22.0553 15.5499 21.7976V14.2307C15.5499 13.973 15.7599 13.7654 16.0075 13.7654C16.255 13.7654 16.4576 13.973 16.4576 14.2307V21.7976Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.fe291d36f532ebe2824432b7565b4a2f.svg";
export { ForwardRef as ReactComponent };